import { css } from '@emotion/css';
import { listStyles } from '@/css/resources/mixins.css';

const getStyles = (styles) => css(listStyles(styles));

export { getStyles };
